import { render, staticRenderFns } from "./RoomView.vue?vue&type=template&id=7c5ed3f2&scoped=true"
import script from "./RoomView.vue?vue&type=script&lang=ts"
export * from "./RoomView.vue?vue&type=script&lang=ts"
import style0 from "./RoomView.vue?vue&type=style&index=0&id=7c5ed3f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5ed3f2",
  null
  
)

export default component.exports